(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialize(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const q = (selector) => root.querySelector(selector);
      const all = (selector) => [...root.querySelectorAll(selector)];
      const form = q('.tvp-form');
      const selector = q('[data-variant-select]');
      const templates = all('template[data-variant]');
      const quantity = q('[data-quantity]');
      const buy = q('[data-buy]');
      const slides = all('[data-slide]');
      const thumbs = all('[data-thumb]');
      let current = 0;
      const preparedImages = new WeakSet();
      function prepareImage(index, priority = 'low') {
        if (!slides.length) return;
        const image = slides[(index + slides.length) % slides.length].querySelector('img');
        if (!image) return;
        image.fetchPriority = priority;
        image.loading = 'eager';
        if (!preparedImages.has(image)) {
          preparedImages.add(image);
          image.decoding = 'async';
          if (typeof image.decode === 'function') image.decode().catch(() => {});
        }
      }
      function prepareNeighbors() {
        if (slides.length < 2) return;
        prepareImage(current + 1);
        prepareImage(current - 1);
      }
      const firstImage = slides[0]?.querySelector('img');
      if (firstImage?.complete) prepareNeighbors();
      else if (firstImage) {
        firstImage.addEventListener('load', prepareNeighbors, { once: true });
        firstImage.addEventListener('error', prepareNeighbors, { once: true });
      }
      function showImage(index, scroll = false) {
        if (!slides.length) return;
        current = (index + slides.length) % slides.length;
        prepareImage(current, 'high');
        slides.forEach((slide, i) => {
          slide.hidden = i !== current;
        });
        prepareNeighbors();
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === current)));
        if (q('[data-count]')) q('[data-count]').textContent = String(current + 1);
        if (scroll && thumbs[current])
          thumbs[current].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('pointerdown', () => prepareImage(i, 'high'), { passive: true });
        thumb.addEventListener('pointerenter', () => prepareImage(i));
        thumb.addEventListener('focus', () => prepareImage(i));
        thumb.addEventListener('click', () => showImage(i, true));
      });
      q('[data-prev]')?.addEventListener('click', () => showImage(current - 1, true));
      q('[data-next]')?.addEventListener('click', () => showImage(current + 1, true));
      q('.tvp-gallery')?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          showImage(current + (event.key === 'ArrowLeft' ? -1 : 1), true);
        }
      });
      let start = null;
      q('.tvp-gallery')?.addEventListener(
        'touchstart',
        (event) => {
          start = { x: event.touches[0].clientX, y: event.touches[0].clientY };
        },
        { passive: true },
      );
      q('.tvp-gallery')?.addEventListener(
        'touchend',
        (event) => {
          if (!start) return;
          const dx = event.changedTouches[0].clientX - start.x;
          const dy = event.changedTouches[0].clientY - start.y;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy))
            showImage(current + (dx < 0 ? 1 : -1), true);
          start = null;
        },
        { passive: true },
      );

      const lightbox = q('[data-lightbox]');
      if (lightbox && typeof lightbox.showModal === 'function') {
        const stage = q('[data-zoom-stage]');
        const large = q('[data-zoom-image]');
        const points = new Map();
        let scale = 1, x = 0, y = 0, baseW = 1, baseH = 1;
        let gesture = null, launcher = null, suppressClickUntil = 0;
        let savedBody = null;
        function paint() {
          const maxX = Math.max(0, (baseW * scale - stage.clientWidth) / 2);
          const maxY = Math.max(0, (baseH * scale - stage.clientHeight) / 2);
          x = Math.max(-maxX, Math.min(maxX, x));
          y = Math.max(-maxY, Math.min(maxY, y));
          large.style.transform = `translate(-50%, -50%) translate(${x}px, ${y}px) scale(${scale})`;
          q('[data-zoom-reset]').textContent = `${Math.round(scale * 100)}%`;
          q('[data-zoom-out]').disabled = scale <= 1;
          q('[data-zoom-in]').disabled = scale >= 5;
          stage.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
        }
        function fit() {
          if (!lightbox.open) return;
          const w = large.naturalWidth || 1, h = large.naturalHeight || 1;
          const ratio = Math.min(stage.clientWidth / w, stage.clientHeight / h);
          baseW = w * ratio; baseH = h * ratio;
          large.style.width = `${baseW}px`; large.style.height = `${baseH}px`;
          paint();
        }
        function zoom(next) { scale = Math.max(1, Math.min(5, next)); paint(); }
        function display(index) {
          showImage(index);
          scale = 1; x = 0; y = 0; points.clear(); gesture = null;
          const original = slides[current].querySelector('img');
          large.alt = original?.alt || '';
          large.src = slides[current].dataset.zoomSrc || original?.src;
          q('[data-zoom-count]').textContent = `${current + 1} / ${slides.length}`;
          q('[data-zoom-prev]').hidden = q('[data-zoom-next]').hidden = slides.length < 2;
          fit();
        }
        large.addEventListener('load', fit);
        slides.forEach((slide, index) => {
          slide.addEventListener('pointerdown', e => { slide._zoomStart = [e.clientX, e.clientY]; });
          slide.addEventListener('pointermove', e => {
            const p = slide._zoomStart;
            if (p && Math.hypot(e.clientX-p[0], e.clientY-p[1]) > 12) suppressClickUntil = Date.now()+500;
          });
          slide.addEventListener('pointercancel', () => { suppressClickUntil = Date.now()+500; });
          const open = () => {
            if (Date.now() < suppressClickUntil || lightbox.open) return;
            launcher = slide;
            savedBody = {position: document.body.style.position, top: document.body.style.top, width: document.body.style.width, overflow: document.body.style.overflow, scroll: window.scrollY};
            document.body.style.position = 'fixed'; document.body.style.top = `-${savedBody.scroll}px`;
            document.body.style.width = '100%'; document.body.style.overflow = 'hidden';
            lightbox.showModal(); display(index); q('[data-zoom-close]').focus();
          };
          slide.addEventListener('click', open);
          slide.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
          });
        });
        function unlock() {
          if (!savedBody) return;
          const saved = savedBody; savedBody = null;
          for (const key of ['position','top','width','overflow']) document.body.style[key] = saved[key];
          window.scrollTo({top: saved.scroll, behavior: 'instant'});
        }
        lightbox.addEventListener('close', () => { unlock(); points.clear(); (slides[current] || launcher)?.focus({preventScroll:true}); });
        q('[data-zoom-close]').addEventListener('click', () => lightbox.close());
        q('[data-zoom-prev]').addEventListener('click', () => display(current-1));
        q('[data-zoom-next]').addEventListener('click', () => display(current+1));
        q('[data-zoom-in]').addEventListener('click', () => zoom(scale+0.5));
        q('[data-zoom-out]').addEventListener('click', () => zoom(scale-0.5));
        q('[data-zoom-reset]').addEventListener('click', () => { x=0; y=0; zoom(1); });
        lightbox.addEventListener('keydown', e => {
          const actions = {ArrowLeft: () => display(current-1), ArrowRight: () => display(current+1), '+': () => zoom(scale+0.5), '=': () => zoom(scale+0.5), '-': () => zoom(scale-0.5), '0': () => zoom(1)};
          if (actions[e.key]) { e.preventDefault(); actions[e.key](); }
        });
        stage.addEventListener('dblclick', e => { e.preventDefault(); zoom(scale > 1 ? 1 : 2.5); });
        stage.addEventListener('wheel', e => { e.preventDefault(); zoom(scale + (e.deltaY < 0 ? .25 : -.25)); }, {passive:false});
        function seed() {
          const p = [...points.values()];
          if (p.length >= 2) {
            const rect = stage.getBoundingClientRect();
            gesture = {distance: Math.max(1, Math.hypot(p[1].x-p[0].x,p[1].y-p[0].y)), scale, x, y, cx:(p[0].x+p[1].x)/2-rect.left-rect.width/2, cy:(p[0].y+p[1].y)/2-rect.top-rect.height/2};
          } else if (p.length) gesture = {px:p[0].x, py:p[0].y, x, y};
          else gesture = null;
        }
        stage.addEventListener('pointerdown', e => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          stage.setPointerCapture(e.pointerId); points.set(e.pointerId,{x:e.clientX,y:e.clientY}); seed();
        });
        stage.addEventListener('pointermove', e => {
          if (!points.has(e.pointerId) || !gesture) return;
          points.set(e.pointerId,{x:e.clientX,y:e.clientY});
          const p = [...points.values()];
          if (p.length >= 2) {
            const rect = stage.getBoundingClientRect();
            scale = Math.max(1,Math.min(5,gesture.scale*Math.hypot(p[1].x-p[0].x,p[1].y-p[0].y)/gesture.distance));
            const ratio = scale/gesture.scale;
            x = (p[0].x+p[1].x)/2-rect.left-rect.width/2-(gesture.cx-gesture.x)*ratio;
            y = (p[0].y+p[1].y)/2-rect.top-rect.height/2-(gesture.cy-gesture.y)*ratio;
          } else if (scale > 1) { x=gesture.x+e.clientX-gesture.px; y=gesture.y+e.clientY-gesture.py; }
          paint();
        });
        for (const type of ['pointerup','pointercancel','lostpointercapture']) stage.addEventListener(type, e => { points.delete(e.pointerId); seed(); });
        const observer = new ResizeObserver(fit); observer.observe(stage);
        const section = root.closest('.shopify-section') || root;
        section.addEventListener('shopify:section:unload', () => { if(lightbox.open) lightbox.close(); unlock(); observer.disconnect(); }, {once:true});
      }
      function normalizeQuantity() {
        const min = Number(quantity.min) || 1;
        const step = Number(quantity.step) || 1;
        const max = quantity.max ? Number(quantity.max) : Infinity;
        let value = Number(quantity.value);
        if (!Number.isFinite(value)) value = min;
        value = Math.max(min, min + Math.round((value - min) / step) * step);
        if (value > max) value = min + Math.floor((max - min) / step) * step;
        quantity.value = String(Math.max(min, value));
        q('[data-minus]').disabled = value <= min;
        q('[data-plus]').disabled = value + step > max;
      }
      q('[data-minus]').addEventListener('click', () => {
        quantity.value = String(Number(quantity.value) - Number(quantity.step || 1));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
      q('[data-plus]').addEventListener('click', () => {
        quantity.value = String(Number(quantity.value) + Number(quantity.step || 1));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
      quantity.addEventListener('change', normalizeQuantity);
      function syncOrderProperties(selected) {
        const holder = q('[data-properties]');
        const source = selected?.content.querySelector('[data-properties-content]');
        if (!holder || !source) return;
        // All selected-variant properties must be real inputs INSIDE the form.
        holder.replaceChildren(...source.cloneNode(true).childNodes);
      }
      function updateVariant(updateUrl = false) {
        const selected = templates.find((template) => template.dataset.variant === selector.value);
        if (!selected) {
          buy.disabled = true;
          return;
        }
        const data = selected.dataset;
        q('[data-summary]').replaceChildren(
          ...selected.content.querySelector('[data-summary-content]').cloneNode(true).childNodes,
        );
        syncOrderProperties(selected);
        const available = data.available === 'true';
        buy.disabled = !available;
        buy.textContent = available ? data.cta : root.dataset.soldOut;
        if (q('[data-express]')) q('[data-express]').hidden = !available;
        if (root.dataset.preorder !== 'true')
          q('[data-status]').textContent = available ? root.dataset.inStock : root.dataset.soldOut;
        const wrap = q('[data-payment-options]');
        const choices = templates.filter(
          (template) =>
            template.dataset.group === data.group && template.dataset.mode !== 'regular',
        );
        wrap.replaceChildren();
        choices.forEach((template) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'tvp-card';
          button.dataset.paymentVariant = template.dataset.variant;
          button.setAttribute('aria-pressed', String(template === selected));
          button.disabled = template.dataset.available !== 'true';
          [...template.content.children]
            .filter((child) => !child.matches('[data-summary-content],[data-properties-content]'))
            .forEach((child) => button.appendChild(child.cloneNode(true)));
          button.addEventListener('click', () => {
            selector.value = template.dataset.variant;
            selector.dispatchEvent(new Event('change', { bubbles: true }));
            q(`[data-payment-variant="${template.dataset.variant}"]`)?.focus({
              preventScroll: true,
            });
          });
          wrap.appendChild(button);
        });
        wrap.hidden = choices.length === 0;
        const selectWrap = q('[data-simple-payment]');
        if (selectWrap)
          selectWrap.hidden = choices.length === templates.length && choices.length > 0;
        quantity.min = data.min;
        quantity.step = data.step;
        if (data.max) quantity.max = data.max;
        else quantity.removeAttribute('max');
        normalizeQuantity();
        const imageIndex = slides.findIndex((slide) => slide.dataset.slide === data.image);
        if (imageIndex >= 0) showImage(imageIndex);
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', data.variant);
          window.history.replaceState(window.history.state, '', url.toString());
        }
      }
      selector.addEventListener('change', () => updateVariant(true));
      form.addEventListener('submit', (event) => {
        normalizeQuantity();
        const selected = templates.find((template) => template.dataset.variant === selector.value);
        if (!selected || selected.dataset.available !== 'true') {
          event.preventDefault();
          return;
        }
        syncOrderProperties(selected);
      }, true);
      updateVariant();
      const description = q('[data-description]');
      const packagePanel = q('[data-panel="package"]');
      const specTarget = q('[data-extra-specs]');
      description
        .querySelectorAll('[data-toyvix-content="package"]')
        .forEach((node) => packagePanel.appendChild(node));
      description
        .querySelectorAll('[data-toyvix-content="specifications"]')
        .forEach((node) => specTarget.appendChild(node));
      const packageTab = q('[data-tab="package"]');
      packageTab.hidden = !packagePanel.children.length;
      const tabs = all('[data-tab]').filter((tab) => !tab.hidden);
      const panels = all('[data-panel]');
      function activateTab(name, focus = false) {
        tabs.forEach((tab) => {
          const active = tab.dataset.tab === name;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });
        panels.forEach((panel) => {
          if (panel.dataset.panel === 'video' && name !== 'video') {
            panel.querySelectorAll('[data-video-player]').forEach((player) => {
              const content = player.querySelector('[data-video-player-content]');
              if (content) content.replaceChildren();
              player.hidden = true;
            });
          }
          panel.hidden = panel.dataset.panel !== name;
        });
      }
      panels.forEach((panel) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute(
          'aria-labelledby',
          `Tab-${panel.dataset.panel}-${root.id.replace('ToyvixProduct-', '')}`,
        );
        panel.tabIndex = 0;
      });
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activateTab(tab.dataset.tab));
        tab.addEventListener('keydown', (event) => {
          let target = null;
          if (event.key === 'ArrowRight') target = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') target = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;
          if (target !== null) {
            event.preventDefault();
            activateTab(tabs[target].dataset.tab, true);
          }
        });
      });
      q('[data-tabs]').hidden = false;
      activateTab('description');
      q('[data-open-shipping]')?.addEventListener('click', () => {
        activateTab('shipping');
      });
      const preorderDialog = q('[data-preorder-dialog]');
      const preorderLauncher = q('[data-open-preorder-dialog]');
      if (preorderDialog && preorderLauncher) {
        preorderLauncher.addEventListener('click', () => {
          if (!preorderDialog.open) preorderDialog.showModal();
          q('[data-preorder-dialog-heading]')?.focus();
        });
        q('[data-close-preorder-dialog]')?.addEventListener('click', () => preorderDialog.close());
        preorderDialog.addEventListener('close', () => preorderLauncher.focus());
        preorderDialog.addEventListener('click', (event) => {
          if (event.target === preorderDialog) preorderDialog.close();
        });
      }
    }
    function scan(scope = document) {
      if (scope.matches?.('[data-tvp]')) initialize(scope);
      scope.querySelectorAll('[data-tvp]').forEach(initialize);
    }
    if (document.readyState === 'loading')
      document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
    else scan();
    if (!window.toyvixProductV2Listener) {
      document.addEventListener('shopify:section:load', (event) => scan(event.target));
      window.toyvixProductV2Listener = true;
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
